import { render, staticRenderFns } from "./Disabled.vue?vue&type=template&id=3c3a568b"
import script from "./Disabled.vue?vue&type=script&lang=js"
export * from "./Disabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports